import { Box, CircularProgress, styled, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { myExpariencesService } from "../../services";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import MyExparienceStats from "../myExparience/statistics/MyExparienceStats";

const PREFIX = "PurchaseGeolocExparienceOverview";

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.root}`]: {},
}));

const PurchaseGeolocExparienceOverview = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { id } = useParams();
  const [exparience, setExparience] = useState(null);
  const [loading, setLoading] = useState(true);

  const isAdmin = useSelector(
    (state) => state.user?.currentUser?.account?.role === "ADMIN"
  );

  useEffect(() => {
    if (id) {
      myExpariencesService
        .fetchSingleExparience(id, isAdmin)
        .then((res) => {
          setExparience(res);
          setLoading(false);
        })
        .catch((err) => {
          enqueueSnackbar(t("toasts.unknownError"), { variant: "error" });
        });
    }
  }, [id, enqueueSnackbar, t, isAdmin]);

  if (loading) {
    <div className="loading-container">
      <CircularProgress size={50} />
      <Typography>{t("loaders.fetching")}</Typography>
    </div>;
  } else
    return (
      <Root>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "4rem",
          }}
        >
          <img
            src={exparience.logoUrl}
            alt="exparience"
            style={{ width: "100%", maxWidth: "650px", objectFit: "contain" }}
          />
          <Typography variant="h6" sx={{ mt: 1 }}>
            {exparience?.displayName || exparience?.name}
          </Typography>
          <Typography
            variant="body1"
            sx={{ mt: 1, mb: 1, maxWidth: "650px" }}
            dangerouslySetInnerHTML={{
              __html: exparience?.description?.initial,
            }}
          />
          <MyExparienceStats exparience={exparience} fromUserDashboard />
        </Box>
      </Root>
    );
};

export default PurchaseGeolocExparienceOverview;
